/**
 * The Vertical Social Video ordered with the order (Twist, 14 Oct 2026): its
 * performable id, for the code outside the tenant that has to tell it from the
 * full slideshow (the Deliverables page, the order form's catalog, the
 * refund). tenants/twt/performable/social-vertical has the product itself.
 */
export const SOCIAL_VERTICAL_ID = 'social-vertical';

/**
 * The order alert for a Vertical Social Video whose refund is the office's to
 * make (`social_vertical_status: 'person'`, .server/social-vertical.ts). The
 * order model raises it while the status stands (TenantOrder.alerts): the
 * dirty pass's alert sweep acknowledges every tenant alert the model does not
 * name, so one raised from anywhere else would be gone on the next pass.
 */
export const SOCIAL_VERTICAL_ALERT_ID = 'social-vertical-refund';
export const SOCIAL_VERTICAL_ALERT_TITLE = 'Vertical social video could not be made, and its refund needs doing by hand.';

/** A catalog product that books it (`required_services` names it). */
export function catalogRowIsSocialVertical(row: { data: { required_services?: readonly string[] } }): boolean {
  return Boolean(row.data.required_services?.includes(SOCIAL_VERTICAL_ID));
}

/**
 * The company's catalog as the order form offers it to an agent with NO
 * branding: without the Vertical Social Video, which is branded-only and
 * would be $16 of nothing (review of #461). The wizard hides it the same way
 * (TwtSocialVerticalJob.eligible); the intake refuses it (bleenk-order-v2.ts).
 */
export function catalogForBranding<C extends { products: Array<{ data: { required_services?: readonly string[] } }> }>(
  catalog: C,
  branded: boolean,
): C {
  return branded ? catalog : { ...catalog, products: catalog.products.filter((row) => !catalogRowIsSocialVertical(row)) };
}

/** The customer has an agent profile to brand it with: any, archived ones too (slideshowProfileIds). */
export function customerBranded(customer: { profiles?: readonly unknown[] } | null | undefined): boolean {
  return (customer?.profiles?.length ?? 0) > 0;
}
